import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";

const WhatsAppButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const phoneNumber = "919167682864"; // India format with country code
  const defaultMessage = "Hi, I would like to inquire about your tax consultancy services.";

  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(defaultMessage);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        {isExpanded && (
          <div className="mb-4 bg-white border border-brand-border rounded-2xl shadow-2xl p-4 max-w-xs animate-in slide-in-from-bottom-5">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                  <MessageCircle className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-brand-navy text-sm">Medacc Consultancy</h3>
                  <p className="text-xs text-green-600">Online</p>
                </div>
              </div>
              <button
                onClick={() => setIsExpanded(false)}
                className="text-brand-muted hover:text-brand-navy transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <p className="text-sm text-brand-navy mb-3">
              Hi there! 👋 How can we help you with your tax needs today?
            </p>
            <button
              onClick={handleWhatsAppClick}
              className="w-full bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-lg transition-colors text-sm"
            >
              Start Chat
            </button>
          </div>
        )}

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="bg-green-500 hover:bg-green-600 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
          aria-label="Chat on WhatsApp"
        >
          {isExpanded ? (
            <X className="w-6 h-6" />
          ) : (
            <MessageCircle className="w-6 h-6 group-hover:scale-110 transition-transform" />
          )}
        </button>
      </div>

      {/* Pulsing Animation */}
      {!isExpanded && (
        <div className="fixed bottom-6 right-6 z-40 pointer-events-none">
          <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-20" style={{ width: '56px', height: '56px' }}></div>
        </div>
      )}
    </>
  );
};

export default WhatsAppButton;
